import "UI/Widget/GridView";
import "Data/Source";
NS("UI.Widget");

UI.Widget.DataGridView = Class(UI.Widget.GridView, {
    source: null,
    sourceMethod: 'page',
    args: null,

    actions: [{
        css: "icon-mode_edit",
        title: "Редактировать",
        "on-click": "onItemEditClick",
        width: 50,
    }, {
        css: "icon-trash-o",
        title: "Удалить",
        "on-click": "onItemRemoveClick",
        width: 50,
    }],

    destroy: function() {
        this.source = null;

        return this.ParentCall();
    },

    gridData: function(offset, limit, callback) {
        var options = Util.merge(Xhr.args(this.args), {
            offset: offset,
            limit: limit
        });

        if (this.filter) {
            options.options = Util.merge(options.options || {}, Xhr.args({
                filter: this.filter
            }, true));
        }
        if (this.order) {
            _.set(options, 'options.order', this.order);
        }

        this.source[this.sourceMethod](options, function(result) {
            if (result) {
                callback({
                    count: result.count,
                    items: result.items
                });
            }
        }).catch(err => console.warn(err.stack));
    }
});
